import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "w-100 flex-shrink-1 flex-grow-1 d-flex flex-column container-wide card bg-white property-list",
  style: {"min-height":"0"}
}
const _hoisted_2 = {
  class: "h-100",
  style: {"overflow":"auto"}
}
const _hoisted_3 = { class: "d-flex flex-row flex-wrap w-100 align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_6 = { class: "mb-0 ml-auto" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "px-3 pt-3 font-weight-bold text-muted" }
const _hoisted_9 = { style: {"padding-top":"1px"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "cil-location-pin mt-3 mr-5",
    style: {"font-size":"40px"}
  })
], -1)
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { class: "mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PropertyFilter = _resolveComponent("PropertyFilter")!
  const _component_LeafletMap = _resolveComponent("LeafletMap")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_translate = _resolveComponent("translate")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_SubmittableDialog = _resolveComponent("SubmittableDialog")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.properties.call?.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    (_ctx.tabView)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: ".p-tabview-nav"
        }, [
          (_ctx.rpcClient.isInternalUser)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-plus",
                class: "ml-auto my-4",
                label: _ctx.i18n.$gettext('Neues Grundstück'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNewPropertyDialog = true))
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_TabView, {
      lazy: true,
      "active-index": _ctx.$route.hash === '#liste' ? 1 : 0,
      class: "h-100 flex-shrink-1 flex-grow-1 d-flex flex-column px-4",
      style: {"min-height":"0"},
      onTabChange: _cache[3] || (_cache[3] = event => _ctx.$router.replace({ hash: event?.index === 0 ? '#karte' : '#liste' })),
      ref: "tabView"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, {
          header: _ctx.i18n.$gettext('Karte')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PropertyFilter, {
              class: "mb-4",
              properties: _ctx.properties.data || [],
              onFilterChanged: _cache[1] || (_cache[1] = filtered => _ctx.propertiesFiltered = filtered)
            }, null, 8, ["properties"]),
            _createVNode(_component_LeafletMap, {
              ref: "leafLetMapRef",
              class: "h-100 card flat",
              properties: _ctx.propertiesFiltered,
              locations: (_ctx.locations.data || [])
            }, null, 8, ["properties", "locations"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_TabPanel, {
          header: _ctx.i18n.$gettext('Liste')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PropertyFilter, {
              class: "mb-4",
              properties: _ctx.properties.data || [],
              onFilterChanged: _cache[2] || (_cache[2] = filtered => _ctx.propertiesFiltered = filtered)
            }, null, 8, ["properties"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Accordion, {
                class: "locations-accordion",
                multiple: true,
                "active-index": []
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertiesClusteredByLocation, (clusterGroup) => {
                    return (_openBlock(), _createBlock(_component_AccordionTab, {
                      key: JSON.stringify(clusterGroup.location)
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          (clusterGroup.location)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(clusterGroup.location.name), 1))
                            : (_openBlock(), _createElementBlock("h4", _hoisted_5, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Unbekannter Standort")
                                  ]),
                                  _: 1
                                })
                              ])),
                          _createElementVNode("h5", _hoisted_6, _toDisplayString((clusterGroup.properties || []).length) + " " + _toDisplayString(_ctx.i18n.$gettext('Grundstücke')), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        (!clusterGroup.properties?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("p", _hoisted_8, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Keine Grundstücke an diesem Standort.")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((clusterGroup.properties || []), (property) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: property.id,
                              class: "row list-row w-100 clickable border-bottom p-4 mx-0 d-flex flex-row align-items-center",
                              onClick: _withModifiers(($event: any) => (_ctx.goToProperty(property.id)), ["stop"])
                            }, [
                              _hoisted_11,
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("p", _hoisted_13, _toDisplayString(property.location?.name || ''), 1),
                                _createElementVNode("h5", _hoisted_14, _toDisplayString(property.name), 1),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.sizeFormatted(property.size)) + ", " + _toDisplayString(property.plat), 1)
                              ])
                            ], 8, _hoisted_10))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["active-index"]),
    _createVNode(_component_SubmittableDialog, {
      visible: _ctx.showNewPropertyDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showNewPropertyDialog) = $event)),
      header: _ctx.i18n.$gettext('Grundstück anlegen'),
      modal: "",
      onHide: _ctx.resetNewModal,
      onSubmit: _withModifiers(_ctx.createProperty, ["prevent","stop"])
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Abbrechen'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.resetNewModal
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Speichern'),
          icon: "pi pi-check",
          autofocus: "",
          disabled: !_ctx.newPropertyLocation || !_ctx.newPropertyName,
          type: "submit"
        }, null, 8, ["label", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_AnimatedInput, {
          modelValue: _ctx.newPropertyName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newPropertyName) = $event)),
          "auto-resize": "",
          label: _ctx.i18n.$gettext('Name des Grundstücks'),
          class: "mb-4",
          required: ""
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.newPropertyLocation,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPropertyLocation) = $event)),
          options: _ctx.locations.data || [],
          "option-label": "name",
          "option-value": "id",
          label: _ctx.i18n.$gettext('Standort'),
          required: ""
        }, null, 8, ["modelValue", "options", "label"])
      ]),
      _: 1
    }, 8, ["visible", "header", "onHide", "onSubmit"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
      _createVNode(_component_Breadcrumb, {
        home: { icon: 'pi pi-home', to: '/' },
        model: _ctx.breadcrumbs
      }, null, 8, ["model"])
    ]))
  ]))
}